import { useState } from "react";
import { Modal } from "src/components/DialogComponent";
import Input from "src/components/ui/Input";
import TGButton from "src/components/ui/TGButton";
import { FlexRow, FlexCol } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { SelectIcon } from "./SelectIcon";

function SelectComment({
  initial,
  onResult,
  zIndex,
}: {
  initial: string;
  onResult: (text: string) => void;
  zIndex?: number;
}) {
  const [openDialog, setOpenDialog] = useState(false);
  const [comment, setComment] = useState(initial);

  const isEmpty = !comment.length;

  function toggleDialog(state: boolean) {
    setOpenDialog(state);
  }

  function BackButton() {
    setOpenDialog(false);
  }

  function submitComment() {
    setOpenDialog(false);
    onResult(comment);
  }

  return (
    <FlexRow
      className={twMerge(isEmpty ? "" : "text-black", "flex items-center justify-between p-9 flex-nowrap font-medium")}
    >
      <FlexCol className="text-[18px]">Комментарий: {isEmpty ? "не указан" : comment}</FlexCol>
      <FlexCol className="shrink-0">
        <button onClick={() => toggleDialog(true)}>
          <SelectIcon isSelect={!isEmpty} />
        </button>
      </FlexCol>
      <Modal zIndex={zIndex ? zIndex + 10 : 70} open={openDialog} toggleDialog={toggleDialog}>
        <header className="px-10 pb-4">
          <h2>Укажите комментарий</h2>
        </header>

        <div className="px-10 py-5 grow">
          <h4 className="text-black mb-2.5">Комментарий</h4>
          <div>
            <Input placeholder="Введите комментарий..." value={comment} onChange={(e) => setComment(e.target.value)} />
          </div>
        </div>

        <footer className="flex justify-between px-10 pt-10 mt-4 border-t">
          <TGButton onClick={BackButton}>Отмена</TGButton>
          <TGButton color="bluedark" onClick={submitComment}>
            Сохранить
          </TGButton>
        </footer>
      </Modal>
    </FlexRow>
  );
}

export default SelectComment;
